import { BaseHttpAdapter } from '~/services/adapters/base-http.adapter';
import {
    CXEnvironments,
    ICXEnvironment
} from '~/types/cx-types/cx-environment.types';
import { ICXCompanyConfiguration } from '~/types/cx-types/cx-company-configuration.types';

export class CXCompanyConfigurationAdapter extends BaseHttpAdapter {
    async fetchCompanyConfiguration(
        cxEnvironment: ICXEnvironment
    ): Promise<ICXCompanyConfiguration> {
        const { awsBucket, domain, prefix, environment } = cxEnvironment;

        // because in development we dont publish to a designated directory
        const domainForUrl =
            environment === CXEnvironments.Development
                ? domain.indexOf('ngrok') > -1
                    ? domain
                    : 'localhost:3000'
                : domain;

        const companyConfigurationJsonpUrl = `https://s3.amazonaws.com/${awsBucket}/${domainForUrl}/${prefix}_configuration.js?xhr=1`;

        return this.apiService.apiRequest<ICXCompanyConfiguration>({
            baseURL: '',
            url: companyConfigurationJsonpUrl,
            isJsonp: true,
            headers: { crossDomain: true }
        });
    }
}
